import { PermissionGate } from "@components/PermissionGate";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  Button,
  Modal,
  ScrollAreaAutosize,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

import { severityColors } from "@constants/colors";

import { useDeleteAllergy } from "@hooks/mutations/patient/useDeleteAllergy";

import { PatientAllergy } from "@customTypes/patient";

import { StyledFullAllergiesModal } from "./FullAllergiesModal.styled";


interface FullSurgicalHistoryModalProps {
  allergies?: PatientAllergy[];
  opened: boolean;
  close: () => void;
}

export const FullAllergiesModal = ({
  allergies = [],
  opened,
  close,
}: FullSurgicalHistoryModalProps) => {
  const { t } = useTranslation();
  const { patientId } = useParams();
  const [currentAllergyId, setCurrentAllergyId] = useState("");

  const { mutate: deleteAllergy, isLoading: isDeletingAllergy } =
    useDeleteAllergy();

  //   const test = [
  //     ...allergies,
  //     ...allergies,
  //     ...allergies,
  //     ...allergies,
  //     ...allergies,
  //     ...allergies,
  //     ...allergies,
  //     ...allergies,
  //   ];

  const severityOne = allergies.filter(item => item.severity === "1");
  const severityTwo = allergies.filter(item => item.severity === "2");
  const severityThree = allergies.filter(item => item.severity === "3");
  const severityFour = allergies.filter(item => item.severity === "4");
  const severityFive = allergies.filter(item => item.severity === "5");

  return (
    <Modal
      centered
      title={<Text fw={500}>{t("view-allergies")}</Text>}
      opened={opened}
      onClose={close}
      scrollAreaComponent={ScrollAreaAutosize}>
      <StyledFullAllergiesModal>
        <div className="dialog-body">
          <div className="severity-wrapper">
            <p>{t("severity-amount", { amount: 1 })}</p>
            <div className="tags-wrapper">
              {severityOne?.length ? (
                severityOne.map(({ allergy, severity, id }, index) => (
                  // <span className={`severity-${severity}`} key={index}>
                  //   {allergy}
                  // </span>

                  <Button.Group key={index}>
                    <Button
                      size="xs"
                      c={
                        severityColors[severity as keyof typeof severityColors]
                          .dark
                      }
                      bg={
                        severityColors[severity as keyof typeof severityColors]
                          .light
                      }
                      fz={13}>
                      {allergy}
                    </Button>
                    <Tooltip
                      label={t("delete")}
                      withArrow
                      events={{ hover: true, focus: true, touch: true }}>
                      <PermissionGate permission="consultations.delete"><Button
                        size="xs"
                        px={"0.5rem"}
                        bg={
                          severityColors[
                            severity as keyof typeof severityColors
                          ].medium
                        }
                        loading={isDeletingAllergy && id === currentAllergyId}
                        onClick={() => {
                          setCurrentAllergyId(id);
                          deleteAllergy({
                            patientId: patientId as string,
                            allergyId: id,
                          });
                        }}>
                        <IconTrash
                          size={16}
                          color={
                            severityColors[
                              severity as keyof typeof severityColors
                            ].dark
                          }
                        />
                      </Button></PermissionGate>
                    </Tooltip>
                  </Button.Group>
                ))
              ) : (
                <Text fz={14} c="dimmed">
                  N/A
                </Text>
              )}
            </div>
          </div>

          <div className="severity-wrapper">
            <p>{t("severity-amount", { amount: 2 })}</p>
            <div className="tags-wrapper">
              {severityTwo?.length ? (
                severityTwo.map(({ allergy, severity, id }, index) => (
                  // <span className={`severity-${severity}`} key={index}>
                  //   {allergy}
                  // </span>
                  <Button.Group key={index}>
                    <Button
                      size="xs"
                      c={
                        severityColors[severity as keyof typeof severityColors]
                          .dark
                      }
                      bg={
                        severityColors[severity as keyof typeof severityColors]
                          .light
                      }
                      fz={13}>
                      {allergy}
                    </Button>
                    <Tooltip
                      label={t("delete")}
                      withArrow
                      events={{ hover: true, focus: true, touch: true }}>
                      <PermissionGate permission="consultations.delete"><Button
                        size="xs"
                        px={"0.5rem"}
                        bg={
                          severityColors[
                            severity as keyof typeof severityColors
                          ].medium
                        }
                        loading={isDeletingAllergy && id === currentAllergyId}
                        onClick={() => {
                          setCurrentAllergyId(id);
                          deleteAllergy({
                            allergyId: id,
                            patientId: patientId as string,
                          });
                        }}>
                        <IconTrash
                          size={16}
                          color={
                            severityColors[
                              severity as keyof typeof severityColors
                            ].dark
                          }
                        />
                      </Button></PermissionGate>
                    </Tooltip>
                  </Button.Group>
                ))
              ) : (
                <Text fz={14} c="dimmed">
                  N/A
                </Text>
              )}
            </div>
          </div>

          <div className="severity-wrapper">
            <p>{t("severity-amount", { amount: 3 })}</p>
            <div className="tags-wrapper">
              {severityThree?.length ? (
                severityThree.map(({ allergy, severity, id }, index) => (
                  // <span className={`severity-${severity}`} key={index}>
                  //   {allergy}
                  // </span>
                  <Button.Group key={index}>
                    <Button
                      size="xs"
                      c={
                        severityColors[severity as keyof typeof severityColors]
                          .dark
                      }
                      bg={
                        severityColors[severity as keyof typeof severityColors]
                          .light
                      }
                      fz={13}>
                      {allergy}
                    </Button>
                    <Tooltip
                      label={t("delete")}
                      withArrow
                      events={{ hover: true, focus: true, touch: true }}>
                      <PermissionGate permission="consultations.delete"><Button
                        size="xs"
                        px={"0.5rem"}
                        bg={
                          severityColors[
                            severity as keyof typeof severityColors
                          ].medium
                        }
                        loading={isDeletingAllergy && id === currentAllergyId}
                        onClick={() => {
                          setCurrentAllergyId(id);
                          deleteAllergy({
                            allergyId: id,
                            patientId: patientId as string,
                          });
                        }}>
                        <IconTrash
                          size={16}
                          color={
                            severityColors[
                              severity as keyof typeof severityColors
                            ].dark
                          }
                        />
                      </Button></PermissionGate>
                    </Tooltip>
                  </Button.Group>
                ))
              ) : (
                <Text fz={14} c="dimmed">
                  N/A
                </Text>
              )}
            </div>
          </div>

          <div className="severity-wrapper">
            <p>{t("severity-amount", { amount: 4 })}</p>
            <div className="tags-wrapper">
              {severityFour?.length ? (
                severityFour.map(({ allergy, severity, id }, index) => (
                  // <span className={`severity-${severity}`} key={index}>
                  //   {allergy}
                  // </span>
                  <Button.Group key={index}>
                    <Button
                      size="xs"
                      c={
                        severityColors[severity as keyof typeof severityColors]
                          .dark
                      }
                      bg={
                        severityColors[severity as keyof typeof severityColors]
                          .light
                      }
                      fz={13}>
                      {allergy}
                    </Button>
                    <Tooltip
                      label={t("delete")}
                      withArrow
                      events={{ hover: true, focus: true, touch: true }}>
                      <PermissionGate permission="consultations.delete"><Button
                        size="xs"
                        px={"0.5rem"}
                        bg={
                          severityColors[
                            severity as keyof typeof severityColors
                          ].medium
                        }
                        loading={isDeletingAllergy && id === currentAllergyId}
                        onClick={() => {
                          setCurrentAllergyId(id);
                          deleteAllergy({
                            allergyId: id,
                            patientId: patientId as string,
                          });
                        }}>
                        <IconTrash
                          size={16}
                          color={
                            severityColors[
                              severity as keyof typeof severityColors
                            ].dark
                          }
                        />
                      </Button></PermissionGate>
                    </Tooltip>
                  </Button.Group>
                ))
              ) : (
                <Text fz={14} c="dimmed">
                  N/A
                </Text>
              )}
            </div>
          </div>

          <div className="severity-wrapper">
            <p>{t("severity-amount", { amount: 5 })}</p>
            <div className="tags-wrapper">
              {severityFive?.length ? (
                severityFive.map(({ allergy, severity, id }, index) => (
                  // <span className={`severity-${severity}`} key={index}>
                  //   {allergy}
                  // </span>
                  <Button.Group key={index}>
                    <Button
                      size="xs"
                      c={
                        severityColors[severity as keyof typeof severityColors]
                          .dark
                      }
                      bg={
                        severityColors[severity as keyof typeof severityColors]
                          .light
                      }
                      fz={13}>
                      {allergy}
                    </Button>
                    <Tooltip
                      label={t("delete")}
                      withArrow
                      events={{ hover: true, focus: true, touch: true }}>
                      <PermissionGate permission="consultations.delete"><Button
                        size="xs"
                        px={"0.5rem"}
                        bg={
                          severityColors[
                            severity as keyof typeof severityColors
                          ].medium
                        }
                        loading={isDeletingAllergy && id === currentAllergyId}
                        onClick={() => {
                          setCurrentAllergyId(id);
                          deleteAllergy({
                            allergyId: id,
                            patientId: patientId as string,
                          });
                        }}>
                        <IconTrash
                          size={16}
                          color={
                            severityColors[
                              severity as keyof typeof severityColors
                            ].dark
                          }
                        />
                      </Button></PermissionGate>
                    </Tooltip>
                  </Button.Group>
                ))
              ) : (
                <Text fz={14} c="dimmed">
                  N/A
                </Text>
              )}
            </div>
          </div>
        </div>
      </StyledFullAllergiesModal>
    </Modal>
  );
};
